<template>
  <div>
    <Header :topic="'TOPICS'" />
    <div class="container text-center" style="padding:12px">

      <div class="row mt-2 mb-3">
        <div class="col-12">
          <div class="btn-toolbar d-flex justify-content-center" role="toolbar" aria-label="Topics Toolbar">
            <div class="channel-header">Topic</div>
            <div class="btn-group flex-wrap">
              <button v-for="(i) in topicNames" :key="i" @click="TopicClick" v-bind:topic-id="i" type="button" :class="(i == topic ? 'btn-success' : 'btn-outline-success')" class="btn btn-sm">{{i}}</button>
            </div>
          </div>
        </div>
      </div>

      <!--hr style="color:#9c9c9c;margin:1rem 0px;margin-left:auto;margin-right:auto;width:360px;" /-->

<MqResponsive :target="['lg', 'xl', 'xxl']">
      <div class="row">
          <div class="col-lg-6 col-xs-12">
            <Sunburst></Sunburst>
          </div>
          <div class="col-lg-6 col-xs-12">
            <WorldSentiment :topic="topic" />
          </div>
      </div>
              <hr class="mt-4 mb-4" style="color:#9c9c9c;" />
 </MqResponsive>

      <main role="main">
        <div class="container" style="padding-top: 0px;padding-bottom: 0px;">
          <div class="row">
            <div class="col-lg-9 col-xs-12">

              <h3 v-if="topic != undefined">{{topic.camelize()}} Topics</h3>
              <h3 v-else-if="channel != undefined">{{channelNames[channel]}}</h3>
              <!--h3 v-else-if="source != undefined">{{this.source}}</h3-->
              <h3 v-else-if="search != undefined">Articles containing "{{this.search}}"</h3>

              <div class="row">
                <div v-for='(a, i) in articleList' :key='a'>
                  <Article :article=a></Article>
                  <ArticleAd v-if="(i%8) == 7 && features.adverts == true"></ArticleAd>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <ins v-if="features.adverts == true" class="adsbygoogle" style="display:block" data-ad-format="fluid" data-ad-layout-key="-6t+ed+2i-1n-4w" data-ad-client="ca-pub-7129978262157669" data-ad-slot="1172211710"></ins>
              <hr style="color:#9c9c9c;" />
              <!--hr style="color:#9c9c9c;" /-->
              <h3>Keyword Trends</h3>
              <TrendKeyword />
              <hr style="color:#9c9c9c;" />
              <ins v-if="features.adverts == true" class="adsbygoogle" style="display:block" data-ad-format="fluid" data-ad-layout-key="-6t+ed+2i-1n-4w" data-ad-client="ca-pub-7129978262157669" data-ad-slot="1172211710"></ins>
              <hr style="color:#9c9c9c;" />
              <h3>Country Trends</h3>
              <TrendCountry />
            </div>
          </div>
        </div>
      </main>
    </div>
    <Footer></Footer>
  </div>
</template>

<style>
.channel-header {
  text-align: left;
  margin:4px 16px 0px 0px;
  font-size: 20px;
}
</style>

<script>
import * as Common from '../modules/common.js'
import Header from '../components/headers/header_logged_out.vue'
import Footer from '../components/headers/footer.vue'
import moment from "moment"
import Article from '../components/widgets/article.vue'
import ArticleAd from '../components/widgets/article_ad.vue'
import Sunburst from '../components/widgets/topics_sunburst.vue'
import WorldSentiment from '../components/widgets/map.vue'
import TrendKeyword from '../components/widgets/trend_keyword.vue'
import TrendCountry from '../components/widgets/trend_country.vue'
import { MqResponsive } from "vue3-mq"
var features = require('../modules/features.js')

String.prototype.camelize = function () {
var separateWord = this.toLowerCase().split(' ');
	for (var i=0; i<separateWord.length; i++) {
	separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
	separateWord[i].substring(1);
	}
	return separateWord.join(' ');
}

const channelNames={
  1:"Business",
  1000:"Politics",
  1001:"Entertainment",
};

export default {
  //runtimeCompiler: true,
  name: 'Index',
  components: {
    Header,
    Footer,
    Article,
    ArticleAd,
    Sunburst,
    WorldSentiment,
    TrendKeyword,
    TrendCountry,
    MqResponsive,
  },
  created() {
    var vm = this;
    this.features = features.features;
    const urlParams = new URLSearchParams(window.location.search);
    vm.topic = urlParams.get('topic');
    if (this.topic == undefined)
      vm.topic = "FINANCIAL"
  },
  mounted() {
    var vm = this;
    var startDate = moment().subtract(1,'week').format('YYYY-MM-DD');
    //All TECHNOLOGY FINANCIAL ENERGY CLIMATE TRAVEL
    let data;
    if (this.topic != undefined)
      data = JSON.stringify({"startDate":startDate,"topic":this.topic.toUpperCase(), "page":0, "size":100,"sort":1,"language":"EN"});
    else if (this.channel != undefined)
      data = JSON.stringify({"startDate":startDate,"channel":parseInt(this.channel), "page":0, "size":100,"sort":1,"language":"EN"});
    else if (this.source != undefined)
      data = JSON.stringify({"startDate":startDate,"fromSource":this.source, "page":0, "size":100,"sort":1,"language":"EN"});
    else if (this.search != undefined)
      data = JSON.stringify({"startDate":startDate,"search":this.search, "page":0, "size":100,"sort":1,"language":"EN"});

    //data = JSON.stringify({"startDate":startDate, "page":0, "fromSource":id, "size":100,"sort":1});
    //Common.AJAX_GetJSON("https://api.pexley.com/articles/GetArticles/"+data, {}, function(data, success) {
    //  vm.articleList = data.result;
    //});

    Common.AJAX_GetJSON("https://api.pexley.com/articles/GetArticles/"+data, {}, function(data, success) {
      vm.articleList = data.result;
    });
  },
  methods: {
    TopicClick: function(event) {
      var id = event.target.getAttribute('topic-id');
      window.location.href = "/topic/?topic="+id;
    }
  },
  data() {
    return {
      topic:null,
      articleList:[],
      channelNames:channelNames,
      source:null,
      search:null,
      topicNames:["FINANCIAL", "TECHNOLOGY", "CLIMATE", "REGULATION", "ENERGY"],
    };
  }     
}
</script>
